export class ContactMechanismPurposeTypes {
    ID: number;
    TYPE?: string;
    DESCRIPTION?: string;
    CREATED_BY?: string;
    CREATED_DATE?: Date;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
}
